import React, { Component } from 'react';
import uaeuLogo from '../images/uaeu-logo-white.png';
import Menu from './Menu';
import MapControls from '../containers/MapControls';
import Search from './Search';
import SearchList from './SearchList';
import FilterList from './FilterList';
import Mapbox from '../utils/Mapbox';

class Sidebar extends Component{
    constructor(props){
        super(props);
        this.searchHandler = this.searchHandler.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.filterCategories(this.props.geoData);

        this.listSelected = 0;
    }

    removeDuplicates(arr, prop) {
        var obj = {};
        for (var i = 0, len = arr.length; i < len; i++) {
            if (!obj[arr[i][prop]]) obj[arr[i][prop]] = arr[i];
        }
        var newArr = [];
        for (var key in obj) newArr.push(obj[key]);
        return newArr;
    }
    
    filterCategories(geoData){
        let categoryArr = [];
        geoData.features.map((feature, i) => {
            var id = feature.properties['icon'];
            var title = feature.properties['category'];
            categoryArr.push({ id, title });
        });
        
        let category = this.removeDuplicates(categoryArr, 'id');
        this.props.setCategory(category);
    }

    searchHandler(e){
        let query = e.target.value.toLowerCase(),
            map = this.props.map,
            locations = this.props.geoData.features;
        
        let sItem =  document.querySelector("#map-categories").querySelectorAll('.filterBox');
        this.listSelected = 0;
        Mapbox.popup.remove();

        sItem.forEach(function(item) {
            if (item.classList.contains('selected')) {
                item.classList.remove('selected')
            }
        });
        
        if(query.length === 0){
            map.setLayoutProperty('uaeu', 'visibility', 'none');
            this.props.filterMap([]);
            Mapbox.popup.remove();
            this.props.map.flyTo({
                center: [55.67900, 24.19760],
                speed: 0.2,
                zoom: 15.2
            });  
            return false;
        }

        var filtered = locations.filter(function(location) {
            var id = location.properties.id.trim().toLowerCase();
            var title = location.properties.title.trim().toLowerCase();
            var type = location.properties.type.trim().toLowerCase();
            return id.indexOf(query) > -1 || title.indexOf(query) > -1 || type.indexOf(query) > -1;
        });
        
        this.props.filterMap(filtered);
        map.setFilter('uaeu', ['in', 'id'].concat(filtered.map(function(feature) {
            return feature.properties.id;
        })));

        map.setLayoutProperty('uaeu', 'visibility', 'visible');
    }

    handleKeyPress(e){
        let item = document.querySelectorAll('.map-search-item'),
            scrollElem = document.getElementById('map-search-list');

        this.props.setActiveFilter(true);
        if(item.length> 0){
            item.forEach((i)=>{
                i.classList.remove('search-selected');
            });
        }
        if(e.keyCode === 40 && this.listSelected <= item.length-1) {
            this.listSelected += 1;
        }

        if(e.keyCode === 38 && this.listSelected > 1) {
            this.listSelected -= 1;
        }

        if(this.listSelected > 0 && item.length> 0){
            item[this.listSelected-1].classList.add('search-selected');
            scrollElem.scrollTop = item[this.listSelected-1].offsetTop - 32;
            if(e.keyCode === 13){
                item[this.listSelected-1].click();
            }
        }
        
    }

    toggleVisualMap(e){
        let mapVisual = document.getElementById('mapVisuals');
        if (mapVisual.classList.contains('selected')) {
            mapVisual.classList.remove('selected');
            this.props.map.setLayoutProperty('uaeu-vector', 'visibility', 'none');
        }else{
            mapVisual.classList.add('selected');
            this.props.map.setLayoutProperty('uaeu-vector', 'visibility', 'visible');
        }
}

    render(){
        return(
            <div id="map-filter" className={ `sidebar ${this.props.menu ? '' : 'filter-hide'}`}>
                <Menu onClick={ (e) => {this.props.menuToggle(this.props.menu ? false : true)} } title={this.props.menu ? 'Hide Menu' : 'Show Menu'}/>
                <MapControls setDirection={this.props.setDirection} mapDirection={this.props.mapDirection}  menu={this.props.menu} menuToggle={this.props.menuToggle} />
                <div className="map-filter-inner">
                    <div className="map-filter-top">
                        <div className="map-filter-img">
                            <img src={require('../images/uaeu-logo-white.png')} alt="UAEU Logo" />
                        </div>
                        <div className="map-filter-search">
                            <Search onChange={this.searchHandler} onKeyUp={this.handleKeyPress}  inputRef={el => this.searchField = el} />
                        </div>
                    </div>
                    <div className="map-filter-bottom">
                        <SearchList fData={this.props.visibleData} field={this.searchField} map={this.props.map} filter={this.props.filterMap}/>
                        <div id="mapVisuals" className="filterBox selected" onClick={this.toggleVisualMap.bind(this)}>
                            <label htmlFor="map-visuals"><img src={require(`../images/map.png`)}/>Map Visuals</label>
                        </div>
                        <FilterList filter={this.props.filterMap} map={this.props.map} data={this.props.mapCategory} geoData={this.props.geoData} activeFilter={this.props.activeFilter} setActiveFilter={this.props.setActiveFilter}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar.js